<div class="attribute-container">
  <div class="attribute-text dropdown">
    <form-factory [formGroup]="formGroup" [model]="chaseChartDeliveryStatus"></form-factory>
  </div>
</div>
